export default {
  select_to_share: 'Seleccione Contactos o Canales para compartir',
  forward: 'Reenviar',
  cancel: 'Cancelar',
};
